//import { image } from 'qr-image';


export const images = 
{ image1: require('./MemoMates.png'),
     image2: require('./Note-Taking.png'),
     image3: require('./password.png'),
     image4: require('./quiz.png'),
     image5: require('./weather.png'),
     image6: require('./emojify.png'),
    
    }

